<template lang="pug">
  #GoTop
    .fixed_box_li
      img(src="@/assets/img/float_wechat.png")
      p 微信公众号
      .box_ewm
        img(src="@/assets/img/bottom_wxgzh.png")
        p 扫描二维码关注我们
    .fixed_box_li(@click="coverFn")
      img(src="@/assets/img/float_contactus.png")
      p 联系我们
    .fixed_box_li(@click="GoTop")
      img(src="@/assets/img/float_top.png")
      p 返回顶部
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      // flag: false
    };
  },
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    },
    coverFn() {
      this.$emit('change', true);
    }
  }
};
</script>
<style lang="scss" scoped>
#GoTop {
  width: 88px;
  height: 220px;
  position: fixed;
  right: 20px;
  bottom: 35%;
  z-index: 99999999;
  .fixed_box_li {
    position: relative;
    width: 88px;
    height: 69px;
    background: #00387D;
    box-shadow: 0px 0px 6px rgba(0,56,125,0.58);
    margin-top: 5px;
    cursor: pointer;
    text-align: center;
    padding: 5px 0;
    .box_ewm {
      // display: none;
      position: absolute;
      right: 98px;
      top: 0;
      width: 0;
      height: 144px;
      background: #FFFFFF;
      box-shadow: 0px 0px 6px rgba(0,56,125,0.58);
      img {
        display: none;
        width: 110px;
        height: 110px;
      }
      p {
        display: none;
        font-size: 12px;
        color: #666666;
      }
    }
    img {
      width: 35px;
      height: 30px;
      margin: auto;
    }
    p {
      font-size: 12px;
      color: white;
      font-weight: 400;
      line-height: 24px;
    }
    &:nth-child(1):hover .box_ewm {
      width: 132px;
      padding: 5px;
      overflow: hidden;
      transition: all 0.3s ease;
      img {
        display: block;
      }
      p {
        display: block;
      }
    }
    &:nth-child(1) {
      margin-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue